'use client';
import { useRef, useState } from 'react';

import { useTimer } from './useTimer';

const leadingZero = (numerous: number) =>
  numerous < 10 ? `0${numerous}` : `${numerous}`;

const getReturnValues = (countDown: number) => {
  const hours = leadingZero(
    Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
  );
  const minutes = leadingZero(
    Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60)),
  );
  const seconds = leadingZero(Math.floor((countDown % (1000 * 60)) / 1000));

  return [hours, minutes, seconds];
};

type TpUseCountdown = {
  targetDate: number;
  onComplete: () => void;
};

export const useCountdown = ({ targetDate, onComplete }: TpUseCountdown) => {
  const [countDown, setCountDown] = useState(targetDate - Date.now());
  const completedRef = useRef(false);

  const { pauseTimer } = useTimer({
    delay: 1000,
    startImmediately: true,
    callback: (time) => {
      const currentTime = countDown - time;
      if (currentTime <= 0) {
        if (!completedRef.current) {
          completedRef.current = true;
          setCountDown(0);
          onComplete();
          pauseTimer();
        }
      } else {
        setCountDown(currentTime);
      }
    },
  });

  return getReturnValues(Math.max(0, countDown));
};
